function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaitoContacts = require('../../../../../lib/saito/ui/modals/saito-contacts/saito-contacts');
var SettingsTemplate = require('./settings.template');
var SettingsOverlay = /*#__PURE__*/function () {
  function SettingsOverlay(app, mod) {
    _classCallCheck(this, SettingsOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.contacts = new SaitoContacts(app, mod, true);
    this.overlay_id = 'redsquare-settings-overlay';
    this.container = '';
    this.onEscapeKeyDown = this.onEscapeKeyDown.bind(this);
  }
  return _createClass(SettingsOverlay, [{
    key: "open",
    value: function open() {
      var _this = this;
      this.container = '';
      this.overlay.show(SettingsTemplate(this.app, this.mod), function () {
        document.removeEventListener('keydown', _this.onEscapeKeyDown);
      });
      this.attachEvents();
    }
  }, {
    key: "close",
    value: function close() {
      document.removeEventListener('keydown', this.onEscapeKeyDown);
      this.overlay.close();
    }
  }, {
    key: "renderInto",
    value: function renderInto() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var host = document.querySelector(container);
      if (!host) {
        return false;
      }
      document.removeEventListener('keydown', this.onEscapeKeyDown);
      this.container = container;
      this.app.browser.replaceElementContentBySelector(SettingsTemplate(this.app, this.mod), container);
      this.attachEvents();
      return true;
    }
  }, {
    key: "rerender",
    value: function rerender() {
      var _this2 = this;
      if (this.container) {
        this.renderInto(this.container);
        return;
      }
      if (!this.getRoot()) {
        this.open();
        return;
      }
      this.overlay.show(SettingsTemplate(this.app, this.mod), function () {
        document.removeEventListener('keydown', _this2.onEscapeKeyDown);
      });
      this.attachEvents();
    }
  }, {
    key: "getRoot",
    value: function getRoot() {
      if (this.container) {
        var host = document.querySelector(this.container);
        if (!host || host.hidden) {
          return null;
        }
        return host.querySelector('.settings');
      }
      return document.querySelector('.saito-overlay .settings');
    }
  }, {
    key: "getModtools",
    value: function getModtools() {
      return this.app.modules.returnModuleBySlug('modtools');
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var root = this.getRoot();
      if (!root) {
        return;
      }
      if (!this.container) {
        document.addEventListener('keydown', this.onEscapeKeyDown);
      }
      this.attachCurationToggle(root);
      this.attachWhitelistEvents(root);
      this.attachBlacklistEvents(root);
    }
  }, {
    key: "attachCurationToggle",
    value: function attachCurationToggle(root) {
      var _this3 = this;
      var container = root.querySelector('#curation-toggle');
      if (!container) {
        return;
      }
      var options = container.querySelectorAll('input[name="redsquare-feed-curation"]');
      options.forEach(function (option) {
        option.addEventListener('change', function () {
          if (!option.checked) {
            return;
          }
          var curated = option.value === 'curated';
          _this3.mod.curated = curated;
          _this3.mod.saveOptions();
          var scroller = document.querySelector('#saito-container');
          if (scroller) {
            scroller.classList.toggle('active-curation', curated);
          }
        });
      });
    }
  }, {
    key: "attachWhitelistEvents",
    value: function attachWhitelistEvents(root) {
      var _this4 = this;
      var whitelistBtn = root.querySelector('#whitelisted-accounts');
      var addWhitelistBtn = root.querySelector('#add-whitelist');
      var modtools = this.getModtools();
      if (whitelistBtn) {
        whitelistBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          _this4.contacts.title = 'Whitelisted Accounts';
          _this4.contacts.multi_button = 'Remove from Whitelist';
          _this4.contacts.callback = function (keys) {
            var _iterator = _createForOfIteratorHelper(keys),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var key = _step.value;
                _this4.app.connection.emit('saito-unwhitelist', key);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            _this4.rerender();
          };
          _this4.contacts.render((modtools === null || modtools === void 0 ? void 0 : modtools.whitelisted_publickeys) || []);
        });
      }
      if (addWhitelistBtn) {
        addWhitelistBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          _this4.contacts.title = 'Saved Keys';
          _this4.contacts.multi_button = 'Add to Whitelist';
          _this4.contacts.callback = function (keys) {
            var _iterator2 = _createForOfIteratorHelper(keys),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var key = _step2.value;
                _this4.app.connection.emit('saito-whitelist', {
                  publicKey: key,
                  duration: -1
                });
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            _this4.rerender();
          };
          _this4.contacts.render();
        });
      }
    }
  }, {
    key: "attachBlacklistEvents",
    value: function attachBlacklistEvents(root) {
      var _this5 = this;
      var blacklistBtn = root.querySelector('#blacklisted-accounts');
      var modtools = this.getModtools();
      if (!blacklistBtn) {
        return;
      }
      blacklistBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        _this5.contacts.title = 'Blacklisted Accounts';
        _this5.contacts.multi_button = 'Remove from Blacklist';
        _this5.contacts.callback = function (keys) {
          var _iterator3 = _createForOfIteratorHelper(keys),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var key = _step3.value;
              _this5.app.connection.emit('saito-unblacklist', key);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          _this5.rerender();
        };
        _this5.contacts.render((modtools === null || modtools === void 0 ? void 0 : modtools.blacklisted_publickeys) || []);
      });
    }
  }, {
    key: "onEscapeKeyDown",
    value: function onEscapeKeyDown(e) {
      if (e.key !== 'Escape' || !this.getRoot()) {
        return;
      }
      e.preventDefault();
      this.close();
    }
  }]);
}();
module.exports = SettingsOverlay;